export enum CommonAppStateKeys {
  RETURN_URL = 'return_url'
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/services/app-state/common-app-state-keys.ts